import { render, staticRenderFns } from "./SkeletonHome.vue?vue&type=template&id=f5414d8c&"
import script from "./SkeletonHome.vue?vue&type=script&lang=js&"
export * from "./SkeletonHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports